import appEnums from 'enums/app';
import noop from 'lib/noop';
import * as Gladly from 'GladlySidekick';

// Whitelist of functions that should be exposed in our public facing API
const LIB_FUNCS = ['getAvailability', 'navigate', 'on', 'show'];
const PRIVATE_LIB_FUNCS = ['reconnect'];

const apiBootstrap = { init };

async function init(config, deviceConfig = { platform: appEnums.platforms.WEB }) {
  apiBootstrap.init = noop; // dont allow init to be called twice
  config.loaderCdn = apiBootstrap.loaderCdn;
  let hasPrivateFuncs = deviceConfig.platform !== appEnums.platforms.WEB;
  try {
    await Gladly.init(config, deviceConfig);
    delete apiBootstrap.loaderCdn;
    exposeApiFunctions();
    if (hasPrivateFuncs) {
      exposePrivateApiFunctions();
    }
  } catch (error) {
    apiBootstrap.init = init; // if init fails, allow it to be called again
    throw error;
  }
}

export default apiBootstrap;

/**
 * Map the whitelisted API functions from Gladly Sidekick to the publicly exposed apiBootstrap
 * This is a way to control what functions we will give developer access to.
 */
const exposeApiFunctions = () => {
  for (let func = LIB_FUNCS[0], i = 0; i < LIB_FUNCS.length; func = LIB_FUNCS[++i]) {
    apiBootstrap[func] = Gladly[func]; // eslint-disable-line import/namespace
  }
};

const exposePrivateApiFunctions = () => {
  for (let func = PRIVATE_LIB_FUNCS[0], i = 0; i < PRIVATE_LIB_FUNCS.length; func = PRIVATE_LIB_FUNCS[++i]) {
    apiBootstrap[func] = Gladly[func]; // eslint-disable-line import/namespace
  }
};
